[
  {
    "codeUnit": "KGM",
    "unit": "kg",
    "descriptionCode": "kilogram"
  },
  {
    "codeUnit": "GL",
    "unit": "g/l",
    "descriptionCode": "gramsPerLitre"
  },
  {
    "codeUnit": "P1",
    "unit": "%",
    "descriptionCode": "percentage"
  },
  {
    "codeUnit": "GRM",
    "unit": "g",
    "descriptionCode": "gram"
  },
  {
    "codeUnit": "NONE",
    "unit": "no unit",
    "descriptionCode": "noUnit"
  },
  {
    "codeUnit": "GRMKGM",
    "unit": "g/kg",
    "descriptionCode": "gramsPerKilogram"
  },
  {
    "codeUnit": "MGM",
    "unit": "mg",
    "descriptionCode": "milligram"
  },
  {
    "codeUnit": "MGMKGM",
    "unit": "mg/kg",
    "descriptionCode": "milligramsPerKilogram"
  }
]
